import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import requireAuth from "components/hoc/requireAuth";
import { Trans } from "react-i18next";

import { connect } from "react-redux";

import { api } from "api";

import {
  showModal,
  hideModal
} from "actions";

import BodyMetrics from "components/BodyMetrics";

class Dashboard extends Component {



  // componentDidMount() {
  //     const roles = localStorage.getItem("roles");
  //     if (roles) {
  //       if (roles.includes("Manager")) {
  //         this.props.history.push("/dashboard/manager");
  //       } else {
  //         this.props.history.push("/dashboard/personnel");
  //       }
  //     }
  // }

  componentDidMount() {
    this.fetchSize();
  }


  fetchSize = () => {
    api.get(`/api/profile/get`).then((response) => {

      if (!response.data.data.bodySize || !response.data.data.tshirtSize || !response.data.data.pantSize)
        this.props.showModal({
          modalType: "body-metrics",
          modalTitle: <Trans desc="Lütfen Seçim Yapınız">sizeSelect</Trans>,
          modalContent: <BodyMetrics hideModal={() => this.props.hideModal("body-metrics")} closeOnEscape={true} />,
          modalFooter: null,
          showCloseButton: false
        });
    })
      .catch((err) => {
        console.error(err);
      });
  };



  render() {

    const roles = localStorage.getItem("roles");
    if (!roles) return null;

    return (
      <Redirect
        to={{
          pathname: roles.includes("Manager")
            ? "/dashboard/manager"
            : "/dashboard/personnel",
          state: {},
        }}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modal: state.modal,
  };
};




export default connect(mapStateToProps, {
  showModal,
  hideModal
})(requireAuth(Dashboard));

